/**
 * Logger Utility
 * Environment-aware logging utility
 */

class Logger {
  private isDevelopment: boolean;

  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development';
  }

  debug(message: string, ...args: unknown[]): void {
    if (!this.isDevelopment) return;
    console.log(`[DEBUG] ${message}`, ...args);
  }

  info(message: string, ...args: unknown[]): void {
    if (!this.isDevelopment) return;
    console.info(`[INFO] ${message}`, ...args);
  }

  warn(message: string, ...args: unknown[]): void {
    console.warn(`[WARN] ${message}`, ...args);
  }

  error(message: string, ...args: unknown[]): void {
    console.error(`[ERROR] ${message}`, ...args);
  }

  table(data: unknown): void {
    if (!this.isDevelopment) return;
    console.table(data);
  }

  time(label: string): void {
    if (!this.isDevelopment) return;
    console.time(label);
  }

  timeEnd(label: string): void {
    if (!this.isDevelopment) return;
    console.timeEnd(label);
  }
}

export const logger = new Logger();
export default logger;
